import { render, staticRenderFns } from "./TodayBlockChart.vue?vue&type=template&id=94619060&scoped=true"
import script from "./TodayBlockChart.vue?vue&type=script&lang=js"
export * from "./TodayBlockChart.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TodayBlockChart.vue?vue&type=style&index=0&id=94619060&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "94619060",
  null
  ,true
)

export default component.exports